var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#131B23"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0987 22.2223C21.1111 21.3581 21.9506 20.1729 22.1728 18.568C23.0123 18.0001 23.9506 16.6174 24.1728 15.605C24.4691 14.247 24.5432 13.2346 23.679 12.889C23.5308 12.8396 23.4074 12.7902 23.2592 12.7655C22.8395 9.55563 20.7901 6.93835 18.074 6.02477C18.2963 5.67909 18.6173 5.3581 19.037 5.13588C18.4197 5.0618 17.4815 5.11119 16.7654 5.67909C15.7778 4.69143 14.0987 4.74082 12.9382 4.93835C13.4568 5.18526 13.8271 5.53094 14.074 5.95069C11.2839 6.81489 9.13577 9.48156 8.71602 12.7408C8.59256 12.7655 8.44442 12.8149 8.29627 12.8643C7.43207 13.2099 7.50614 14.2223 7.80244 15.5803C8.02466 16.5927 8.96293 17.9754 9.80244 18.5433C9.99997 20.1235 10.8642 21.3087 11.8518 22.1729C11.4568 22.8396 10.8395 23.3581 9.97528 23.7038C9.60491 23.8272 9.23454 23.926 8.88886 24.0495C8.86417 24.0495 8.81479 24.0741 8.79009 24.0741C7.25923 24.5186 5.90121 24.889 4.83948 25.3828C7.53084 28.5433 11.5308 30.568 15.9753 30.568C20.4444 30.568 24.4444 28.5433 27.1111 25.3828C25.7531 24.7161 23.9012 24.3211 21.8024 23.6297C21.037 23.3087 20.4691 22.8396 20.0987 22.2223Z",
    fill: "#2E3452"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d0f3813c32dd6dd26802c56aaf77f6d8.svg";
export { ForwardRef as ReactComponent };